module.exports = __webpack_public_path__ + "img/574ac3b.jpg";